<template>
    <div>
        <v-card>
            <v-card-actions>
                <v-btn
                    color="blue"
                    depressed
                    class="white--text"
                    @click="$refs.file.click()"
                >
                    Séléctionner
                    <v-icon right>mdi-progress-upload</v-icon>
                </v-btn>
                <v-btn
                    color="orange"
                    depressed
                    class="white--text"
                    @click="reset"
                >
                    Reset
                    <v-icon right>mdi-lock-reset</v-icon>
                </v-btn>
                <v-btn
                    color="purple"
                    depressed
                    class="white--text"
                    @click="crop"
                >
                    Crop
                    <v-icon right>mdi-crop</v-icon>
                </v-btn>
                <v-spacer/>
            </v-card-actions>
            <v-divider/>
            <v-card-text>
                <v-container fluid>
                    <input
                        v-show="false"
                        type="file"
                        ref="file"
                        @change="onFileSelected"
                        accept="image/*"
                    />
                    <v-row justify="center" align="center">
                        <v-col cols="8">
                            <cropper
                                class="cropper"
                                ref="cropper"
                                stencil-component="circle-stencil"
                                :src="selectedImage"
                                :debounce="false"
                                :default-transforms="defaultTransforms"
                                :stencil-props="{ aspectRatio: 1}"
                                @change="change"
                            >
                            </cropper>
                        </v-col>
                        <v-col cols="4">
                            <v-row justify="center" align="center">
                                <v-col cols="6">
                                    <v-avatar size="120">
                                        <preview :width="120" :height="120" :image="imagePreview" :coordinates="coordinates"/>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="6">
                                    <v-avatar size="100">
                                        <preview :width="100" :height="100" :image="imagePreview" :coordinates="coordinates"/>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="4">
                                    <v-avatar size="80">
                                        <preview :width="80" :height="80" :image="imagePreview" :coordinates="coordinates"/>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="4">
                                    <v-avatar size="60">
                                        <preview :width="60" :height="60" :image="imagePreview" :coordinates="coordinates"/>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="4">
                                    <v-avatar size="40">
                                        <preview :width="40" :height="40" :image="imagePreview" :coordinates="coordinates"/>
                                    </v-avatar>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <input type="hidden"/>
    </div>
</template>

<script>
import {Cropper, Preview} from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import {ref} from "vue";
import useTools from "@/use/Tools";

export default {
    name: "ImageCropper",
    components: {
        Cropper,
        Preview,
    },
    setup(props, { emit }) {
        const {$refs} = useTools();

        const selectedFile = ref(null);
        const savedImage = ref(null);
        const selectedImage = ref(null);
        const imagePreview = ref(null);
        const canvas = ref(null);
        const coordinates = ref(null);

        function change(data) {
            coordinates.value = data.coordinates;
            canvas.value = data.canvas;
            imagePreview.value = data.image;
            save();
        }

        function defaultTransforms() {
            return {
                rotate: 0,
                flip: {
                    horizontal: false,
                    vertical: false,
                },
            };
        }

        function onFileSelected(event) {
            try {
                selectedFile.value = event.target.files[0];
                selectedImage.value = URL.createObjectURL(selectedFile.value);
                savedImage.value = selectedImage.value;
            } catch {
                selectedImage.value = null;
            }
        }

        function reset() {
            selectedImage.value = savedImage.value;
        }

        function crop() {
            selectedImage.value = canvas.value.toDataURL();
        }

        function save() {
            const result = $refs.cropper.getResult();
            coordinates.value = result.coordinates;
            canvas.value = result.canvas;
            imagePreview.value = result.image;
            // this.$emit('input', image);
            if (result.canvas) {
                result.canvas.toBlob((blob) => {
                    // form.append("file", blob);
                    emit('input', blob);
                }, "image/jpeg");
            }
        }

        return {
            selectedFile,
            savedImage,
            selectedImage,
            imagePreview,
            canvas,
            coordinates,
            change,
            defaultTransforms,
            onFileSelected,
            reset,
            crop,
            save,
        }
    }
}
</script>